// extracted by mini-css-extract-plugin
module.exports = {"description":"Item_description__33X_o","large":"Item_large__2QTo8"};